var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentTag,{tag:"component",staticClass:"n-badge",class:`badge-${_vm.type}`,attrs:{"href":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }